import { LuGraduationCap } from "react-icons/lu";
import { TbAward, TbCrown, TbUsers } from "react-icons/tb";

export const process = [
    {   
        id: '01',
        title: 'Building Trust',
        subtitle: 'Laying the Foundation for Success',
        desc: `Trust is the foundation of our collaboration. By embracing transparency and fully understanding your unique vision, we’ll create something extraordinary, together.`
    },
    {   
        id: '02',
        title: 'Fostering Collaboration',
        subtitle: 'Aligning Our Strengths',
        desc: `Partnerships thrive on communication and a deep alignment with your brand's goals. Together, we’ll blend our strengths to drive your success.`
    },
    {   
        id: '03',
        title: 'Delivering Impactful Results',
        subtitle: 'Turning Vision into Reality',
        desc: `With meticulous attention to detail and a commitment to excellence, I’m here to turn our shared vision into tangible success for your business.`
    }
];


export const certData = [
        {
            icon: <LuGraduationCap/>,
            title: `Bachelor's in Design and Systems Development`,
            date: '2022',
            source: 'Foundation Assis Gurgacz University'
        },
        {
            icon: <TbAward/>,
            title: 'Introduction to Computer Science',
            date: '2024',
            source: 'Harvard University'
        },
        {
            icon: <TbAward/>,
            title: 'Technical Degree in Systems Development',
            date: '2017',
            source: 'SENAI/SC'
        },
        {
            icon: <TbAward/>,
            title: 'UI/UX Design Essentials',
            date: '2021',
            source: 'BYOL'
        },
        {
            icon: <TbAward/>,
            title: 'Agile Leadership to Facilitate a Hyper Productive Team',
            date: '2024',
            source: 'Accelebrate'
        },
]

export const voluntData = [
    {
        icon: <TbCrown />,
        title: 'Web Development Project Leader',
        date: '2017',
        source: 'SENAI/SC'
    },
    {
        icon: <TbUsers />,
        title: 'Volunteer Jiu-Jitsu Assistant Instructore',
        date: '2015',
        source: `São Francisco do Sul's Community Center`
    },
]